const state = () => ({
  reviews: {
    1: {
      title: 'title',
      text: 'text',
      name: 'RpgEpic123',
      rating: 5,
    },
    2: {
      title: 'title',
      text: 'text',
      name: 'RawJunky',
      rating: 5,
    },
    3: {
      title: 'title',
      text: 'text',
      name: 'FizzliviSphema',
      rating: 5,
    },
    4: {
      title: 'title',
      text: 'text',
      name: 'MasterBest069',
      rating: 5,
    },
    5: {
      title: 'title',
      text: 'text',
      name: 'UgaraticKroolKat',
      rating: 5,
    },
    6: {
      title: 'title',
      text: 'text',
      name: 'Amteleronnnnn',
      rating: 5,
    },
    7: {
      title: 'title',
      text: 'text',
      name: 'JiggySpot',
      rating: 5,
    },
    8: {
      title: 'title',
      text: 'text',
      name: 'Chauchooo',
      rating: 5,
    },
    9: {
      title: 'title',
      text: 'text',
      name: 'Broday56',
      rating: 5,
    },
    10: {
      title: 'title',
      text: 'text',
      name: 'Brown',
      rating: 5,
    },
    11: {
      title: 'title',
      text: 'text',
      name: 'Captain Speedo',
      rating: 5,
    },
    12: {
      title: 'title',
      text: 'text',
      name: 'Dunamito',
      rating: 5,
    },
    13: {
      title: 'title',
      text: 'text',
      name: 'R35',
      rating: 5,
    },
    14: {
      title: 'title',
      text: 'text',
      name: 'Rhelvis',
      rating: 5,
    },
    15: {
      title: 'title',
      text: 'text',
      name: 'iamtns',
      rating: 5,
    },
    16: {
      title: 'title',
      text: 'text',
      name: 'Yak',
      rating: 5,
    },
    17: {
      title: 'title',
      text: 'text',
      name: 'IVBES',
      rating: 5,
    },
    18: {
      title: 'title',
      text: 'text',
      name: 'g-roh',
      rating: 5,
    },
    19: {
      title: 'title',
      text: 'text',
      name: 'ubong inwang',
      rating: 5,
    },
    20: {
      title: 'title',
      text: 'text',
      name: 'iamtns',
      rating: 5,
    },
    21: {
      title: 'title',
      text: 'text',
      name: 'Pepsi Zero',
      rating: 5,
    },
    22: {
      title: 'title',
      text: 'text',
      name: 'JiggySpot',
      rating: 5,
    },
    23: {
      title: 'title',
      text: 'text',
      name: 'Will123Darth368',
      rating: 5,
    },
    24: {
      title: 'title',
      text: 'text',
      name: 'Hamilton_KingLw33es',
      rating: 5,
    },
    25: {
      title: 'title',
      text: 'text',
      name: 'IanVital',
      rating: 5,
    },
    26: {
      title: 'title',
      text: 'text',
      name: 'JackSUN.X0X367',
      rating: 5,
    },
    27: {
      title: 'title',
      text: 'text',
      name: 'TopicSilly',
      rating: 5,
    },
    28: {
      title: 'title',
      text: 'text',
      name: 'Neo_Treasure',
      rating: 5,
    },
    29: {
      title: 'title',
      text: 'text',
      name: 'Armando A.',
      rating: 5,
    },
  },
});

const getters = {
  review: (state) => (id) => state.reviews[id],
};


export default {
  state,
  getters,
};
